import { TUpdateEnabledSectionsParams } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const updateEnabledSections = async (
  params: TUpdateEnabledSectionsParams
): Promise<void> => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
